<app-context-menu
  [options]="{
    width: '160px',
    openOnHover: true,
    interactionDisabled: true,
    dark: true,
    tiny: true,
  }"
  verticalPosition="top"
  position="center"
  [disabled]="disabled()"
  #menu
>
  <div contextButton>
    <ng-content></ng-content>
  </div>

  @if (menu.isOpen) {
    <div contextContent>
      @let users = getFavoritedUsers() | async;
      @if (users?.length) {
        @for (user of users; track user) {
          {{ user }}
        }
      } @else {
        Favorite
      }
    </div>
  }
</app-context-menu>
